module.exports = __webpack_public_path__ + "static/media/unhappy-new.a257331a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/unhappy-new.svg
// module id = 811
// module chunks = 0